import { Modal, Space, Table, Typography } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { PaginationComponent } from "../../Common/Pagination/PaginationComponent";
import PermissionCheck from "../../Common/PermissionCheck";
import { useDeleteStage, useFetchStages } from "../../entities/api";
import { useFetchStagesPagination } from "../../entities/api/useStagesAPI";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import { useHandlePagination } from "../../hooks/useHandlePagination";
import AddNewStage from "./AddNewStage";
import { getColumns } from "./columnsRepository";

const PermissionName = PermissionNames.STAGE;

const TableToolbar = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
`;

const SeasonStages = () => {
  const { formatMessage } = useIntl();
  const [filteredData, setFilteredData] = useState([]);
  const { sport, organizationId, seasonId, customerId } = useParams();
  const pageRef = useRef();
  const { pageSize, currentPage, handlePaginationChange, offset, pageSizeOptions } = useHandlePagination();
  const { data: stagesData, isLoading: isFetchLoading } = useFetchStagesPagination({
    limit: pageSize,
    offset,
  });
  const { mutate: deleteFn, isPending: isDeleteLoading } = useDeleteStage();
  const [modal, contextHolder] = Modal.useModal();

  const data = useMemo(() => stagesData?.data || [], [stagesData?.data]);
  const nextLink = useMemo(() => stagesData?.links?.next, [stagesData?.links?.next]);

  const handleDeleteIntent = (stageCode) => {
    modal.confirm({
      content: formatMessage({ id: "delete.item.confirm" }),
      okType: "danger",
      okText: formatMessage({
        id: "delete",
        defaultMessage: "Delete",
      }),
      onOk: () => deleteFn(stageCode),
    });
  };

  useEffect(() => {
    if (data) {
      setFilteredData(data);
    }
  }, [data]);

  return (
    <React.Fragment>
      {contextHolder}
      <>
        <Space direction="vertical" style={{ width: "100%" }}>
          <TableToolbar>
            <Typography.Title level={4}>
              {formatMessage({
                id: "stages",
              })}
            </Typography.Title>
            <Space
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.CREATE]}>
                <AddNewStage />
              </PermissionCheck>
              .
            </Space>
          </TableToolbar>
          <Table
            columns={getColumns({
              formatMessage,
              pageRef,
              customerId: customerId,
              sport: sport,
              seasonId: seasonId,
              organizationId: organizationId,
              handleDeleteIntent,
              refetch: () => {},
            })}
            dataSource={filteredData}
            size="small"
            pagination={{
              current: currentPage,
              defaultPageSize: pageSize,
              showSizeChanger: true,
              pageSizeOptions,
              showQuickJumper: false,
              total: nextLink ? offset + data.length + 1 : data.length + offset,
              position: ["bottomCenter"],
              onChange: handlePaginationChange,
              showTotal: (total, range) => (
                <PaginationComponent pageNumber={currentPage} pageSize={pageSize} total={total} range={range} />
              ),
            }}
            rowKey={(x) => x.stageCode}
            loading={isFetchLoading || isDeleteLoading}
          />
        </Space>
      </>
    </React.Fragment>
  );
};

export default SeasonStages;
